import { ProductTagBase } from '../ProductTagBase';
import { isDate, isNumber } from '@fxts/core';
import klass from '../style/ProductTag.module.scss';
import { ProductTimeHelper } from '../../ProductCard/utils/ProductTimeHelper';

export class NftTag extends ProductTagBase<Date | number> {
  private getDiffTimeLabel(date: Date): string | undefined {
    const diff = ProductTimeHelper.diffDate(new Date(date), new Date());
    const lang = { lng: this.data.lang };

    if (diff.day >= 4 || diff.second < 0) {
      return undefined;
    }
    if (diff.day > 0) {
      return ET('mps2::product::tag::period_limited_day', { day: diff.day, lng: this.data.lang });
    }
    return ET('mps2::product::tag::period_limited', { time: ProductTimeHelper.formatDiff(diff), ...lang });
  }

  protected makeLabel(): string | undefined {
    if (isDate(this.data.value)) {
      return this.getDiffTimeLabel(this.data.value);
    }
    if (isNumber(this.data.value)) {
      return ET('mps2::product::tag::quantity_limited', { count: this.data.value, lng: this.data.lang });
    }
  }

  protected styles(): string {
    return klass.nft;
  }

  isTimerNeeded(): boolean {
    return isDate(this.data.value);
  }
}
